import { Component, Output, EventEmitter } from '@angular/core';
import { VisitorService, VisitorResponse } from '../../../services/visitor.service';

declare const echarts: any;

@Component({
  selector: 'app-bar-graph',
  templateUrl: './bar-graph.component.html',
  styleUrls: ['./bar-graph.component.css']
})
export class BarGraphComponent {

  option: any;
  // data: Array<any>;
  // data: number[][];
  data: VisitorResponse[] //cache last response so that we can modify it with single day updates

  @Output()
  updateCounts = new EventEmitter<any>();

  constructor(private _visitorService: VisitorService) {
    // Create a subscription to updates from Visitor Service
    _visitorService.getVisitorsForTodaySubject().subscribe((countResponse: number) => {
      if (this.data != undefined) {
        this.data[0].values[this.data[0].values.length - 1].value = countResponse;
        this.buildGraph(this.data);
      }
    })

    _visitorService.getVisitorSubject().subscribe((visitorResponses: VisitorResponse[]) => {

      if(visitorResponses.length <= 0) {
        this.updateCounts.emit({today:0, total:0});
        return;
      }
      
      let totalCount = 0;
      for(var response of visitorResponses) {
        totalCount += response.values.map(v => v.value).reduce((p, c) => { return p + c });
      }
      this.updateCounts.emit({today: response.values.slice(-1)[0].value, total: totalCount});
      this.buildGraph(visitorResponses);
    })
  }

  buildGraph(visitorResponses: VisitorResponse[]) {
    this.data = visitorResponses;

    // The names at the bottom of the graph
    let xAxisData = [];
    // The values for each column, can be multiple (compare graph)
    let values: number[][] = [];
    // The options sent to the graph itself for how to display our data
    let graphOptions: any[] = [];

    // Loop through every response from visitor service
    // For the compare mode, the response will be an array of size n
    // For single day mode, the response will be an array of size 1
    for (let i = 0; i < visitorResponses.length; i++) {
      const visitorResponse: VisitorResponse = visitorResponses[i];
      values[i] = [];

      visitorResponse.values.forEach(visitor => {
        // Take names from the first response only (they should all be the same)
        if(i == 0) {
          xAxisData.push(visitor.name);
        }
        // Update values array with the values from each response
        values[i].push(visitor.value);
      });

      // Indicate how to display this set of data
      let graphOption = {
        name: visitorResponse.name,
        type: 'bar',
        data: values[i],
        animationDelay: function(idx) {
          // Animation delay increases for each loop
          return idx * 10 + (i * 100);
        }
      }
      graphOptions.push(graphOption);
    }

    // Send the chart all of the new data and options to display
    this.updateChart(xAxisData, values, graphOptions);
  }

  echartsInstance: any;

  onChartInit(ec) {
    this.echartsInstance = ec;
  }

  updateChart(xAxisData, values: number[][], graphOptions: any[]) {
    let bargraph = {
      backgroundColor: echarts.bg,
      color: ['red', 'blue', 'green'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      // legend: {
      //   data: ['Number of Visitors'],
      //   align: 'left',
      //   textStyle: {
      //     color: '#484848',
      //   },
      // },
      xAxis: [
        {
          data: xAxisData,
          silent: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: '#bbbbbb',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#484848',
            },
          },
        },
      ],
      yAxis: [
        {
          axisLine: {
            lineStyle: {
              color: '#bbbbbb',
            },
          },
          splitLine: {
            lineStyle: {
              color: '#ebeef2',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#484848',
            },
          },
        },
      ],
      // series: [
      //   {
      //     name: 'Number of Visitors 2017',
      //     type: 'bar',
      //     data: values[0],
      //     animationDelay: function(idx) {
      //       return idx * 10;
      //     },
      //   },
      //   {
      //     name: 'Number of Visitors 2018',
      //     type: 'bar',
      //     data: values[1],
      //     animationDelay: function(idx) {
      //       return idx * 10 + 100;
      //     },
      //   },
      // ],
      animationEasing: 'elasticOut',
      animationDelayUpdate: function(idx) {
        return idx * 5;
      },
    };

    // Add the current data series options to the bargraph options template
    Object.assign(bargraph, { "series" : graphOptions })

    // This updates the graph (it watches the this.option variable)
    this.option = bargraph;
  }
}
